import React from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Button from '../button/Button';
import Icon from '../icon/Icon';
import text from '../../text';
import { useDownloadAll } from '@/hooks/useDownloadAll';

interface DownloadAllButtonProps {
  projectId: number;
}

const DownloadAllButton = ({
  projectId,
}: DownloadAllButtonProps) => {
  const { zipProgress, zipLoading, startDownload, cancelDownload } = useDownloadAll({ projectId });
  return (
    <Button
      className={classNames(
        'download-all-button',
        zipLoading && 'loading'
      )}
      variant='outline-primary'
      icon={
        zipLoading
          ? 'zip'
          : 'download'
      }
      onClick={startDownload}
    >
      {!zipLoading ? (
        text('downloadAll')
      ) : (
        <div className='download-all-content'>
          <span>{text('zipping')} <span className='ellipsis'>...</span></span>
          {zipProgress !== null ? <span className='pct'>{`${zipProgress}%`}</span> : null}

          <OverlayTrigger
            placement='top'
            overlay={
              <Tooltip id='cancel-download-tooltip'>
                {text('cancelDownload')}
              </Tooltip>
            }
          >
            <Icon
              icon='close'
              className='cancel-download-icon'
              // @ts-expect-error untyped
              onClick={(ev) => {
                ev.stopPropagation();
                cancelDownload();
              }}
            />
          </OverlayTrigger>
        </div>
      )}
    </Button>
  );
};

export default DownloadAllButton;
